<template>
    <div class="common-redpacket-hk26" :class="{ 'common-redpacket-hk26-preview': props.isPreview }">
        <img :src="state.bull" class="common-redpacket-hk26-bull" />
        <img :src="state.title" class="common-redpacket-hk26-title" />
        <div class="common-redpacket-hk26-packet-1" />
        <div class="common-redpacket-hk26-packet-2" />
        <div class="common-redpacket-hk26-packet-3" />
        <a class="common-redpacket-hk26-btn" @click="() => props.sendRedpack && props.sendRedpack()"> 开启贺岁红包 </a>
    </div>
</template>

<script >
import { defineProps, onMounted, reactive } from 'vue-demi';
import { getH5Images } from './config';
const __sfc_main = {};
__sfc_main.props = ['sendRedpack', 'isPreview'];
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const state = reactive({
    bull: '',
    title: ''
  });
  onMounted(async () => {
    const config = await getH5Images();
    state.bull = config.bull;
    state.title = config.title;
  });
  return {
    props,
    state
  };
};
export default __sfc_main;
</script>

<style lang="less" scoped>
.common-redpacket-hk26 {
    width: 7.5rem;
    margin: 0 auto;
    height: 100vh;
    position: relative;
    overflow: hidden;
    background: url(../HK2606/images/h5/logo.png) no-repeat top 0.4rem left 0.33rem ~'/' auto 0.42rem,
        url(../HK2606/images/h5/img_5.jpg) repeat-x center center/auto 100%;

    &-preview {
        height: 14rem;
    }

    &-bull {
        position: absolute;
        width: 7.5rem;
        left: 50%;
        transform: translateX(-50%);
        bottom: 0;
        z-index: 10;
    }

    &-title {
        position: absolute;
        width: 7.01rem;
        height: 2.69rem;
        top: 1.34rem;
        left: 50%;
        transform: translateX(-50%);
        z-index: 9;
    }

    &-btn {
        position: absolute;
        width: 3rem;
        height: 3rem;
        bottom: 0.9rem;
        left: 50%;
        transform: translateX(-50%);
        opacity: 0;
        color: transparent;
        z-index: 11;
    }

    &-packet {
        &-1 {
            position: absolute;
            width: 3.16rem;
            height: 3.2rem;
            right: 0.1rem;
            top: 6rem;
            background: url(./images/h5/packet-1.png) no-repeat center/100% 100%;
            animation: packet1Float 3s ease-in-out infinite;
        }

        &-2 {
            position: absolute;
            width: 5.98rem;
            height: 3.2rem;
            right: -3.5rem;
            top: 1.98rem;
            background: url(./images/h5/packet-2.png) no-repeat center/100% 100%;
            animation: packet2Float 3.5s ease-in-out infinite;
        }

        &-3 {
            position: absolute;
            width: 4.16rem;
            height: 3.2rem;
            left: -1.5rem;
            top: 3rem;
            background: url(./images/h5/packet-3.png) no-repeat center/100% 100%;
            animation: packet3Float 2.8s ease-in-out infinite;
        }
    }
}

@keyframes packet1Float {

    0%,
    100% {
        transform: translate(0, 0);
    }

    25% {
        transform: translate(0.01rem, -0.18rem);
    }

    50% {
        transform: translate(-0.008rem, -0.3rem);
    }

    75% {
        transform: translate(0.01rem, -0.15rem);
    }
}

@keyframes packet2Float {

    0%,
    100% {
        transform: translate(0, 0);
    }

    25% {
        transform: translate(-0.012rem, -0.22rem);
    }

    50% {
        transform: translate(0.01rem, -0.35rem);
    }

    75% {
        transform: translate(-0.01rem, -0.18rem);
    }
}

@keyframes packet3Float {

    0%,
    100% {
        transform: translate(0, 0);
    }

    25% {
        transform: translate(0.01rem, -0.2rem);
    }

    50% {
        transform: translate(-0.01rem, -0.32rem);
    }

    75% {
        transform: translate(0.008rem, -0.15rem);
    }
}
</style>
